import { type FooterData } from '@/features/cms/components/CMS/types'
import { Footer } from '@/features/shared/components/Footers/Footer'
import { ReferenceRenderer } from '@/features/cms/components/CMS/ReferenceRenderer'
import { CMSErrorHandler } from '@/features/cms/components/CMS/CMSErrorHandler'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'

/**
 * This component corresponds to the `footer` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/footer
 * - **Production** - https://cms.shipt.com/content-type/pool/footer
 */
export const CMSFooter = ({ content_type_id, id, data }: FooterData) => {
  try {
    return (
      <div {...getCMSWrapperProps({ content_type_id, id })}>
        <Footer>
          <ReferenceRenderer references={data.references} />
        </Footer>
      </div>
    )
  } catch (error) {
    return <CMSErrorHandler error={error} contentTypeId={content_type_id} id={id} />
  }
}
